<nav class="navbar d-block d-md-none navbar-expand-lg navbar-light fixed-top" id="mainNavmobile">
  <div class="container-fluid"> 
       <a class="navbar-brand" href="/">
                <img src="assets/img/logo.png" class="img-fluid" alt=""> 
              </a>
             
       <ul class="ml-auto my-auto my-lg-2 my-lg-0 align-items-center">
         
        
           <a class="cart-icon" routerLinkActive="active" [routerLink]="['/cart']">
                    <i class="fas fa-shopping-cart"></i>
          <span class="cart-count"*ngIf="totalcartItem > 0" >{{totalcartItem}} </span>
      </a>
  

        <li id="openHamBurger" class="nav-item nav-menu" (click)="ishamClicked = !this.ishamClicked;">
          <span> </span>
          <span class="right-ar"> </span>
          <span> </span>
        </li>
       </ul>
  </div>
 
 
 </nav>
   
 <div class="full-screen-menu d-block d-md-none section fadeIn" [ngClass]="{show: ishamClicked}">
 <div class="container">
   <div class="full-content">

 <div class="row">
 <div class="col-sm-7 right-menu">

  <div class="row align-items-center">
    <div class="col-8">
      <form class="form-inline" #searchformdmob="ngForm" (ngSubmit)="onsearchsubmit(searchformdmob)">
        <a class="navbar-search btn btn-sm btn-success"> <i class="fas fa-search"></i></a>
         <div class="form-group mb-0">
            <input type="text" class="form-control search-form" name="searchtxt" 
            id="search1" placeholder="{{ 'HOME.type_search' | translate }}" required ngModel>
         </div>
      </form>    
    </div>
  
  <div class="col-4 welcome-user text-right">
    <a *ngIf="isloggedin" aria-haspopup="true" aria-expanded="false"> Hala, {{uname}}</a>          
  </div>
  </div>

  <hr class="hr-nav">
 <h2 class="mb-0"> <a [routerLink]="['/about']" routerLinkActive="active" class="btn btn-link"> {{ 'HOME.ABOUT' | translate }} </a> </h2>
 <h2 class="mb-0"> <a [routerLink]="['/menu']" routerLinkActive="active" class="btn btn-link">{{ 'HOME.MENU' | translate }}</a> </h2>
 <h2 class="mb-0"> <a [routerLink]="['/shisha']" routerLinkActive="active" class="btn btn-link">{{ 'HOME.SHISHA' | translate }}</a> </h2>
 <h2 class="mb-0"> <a [routerLink]="['/career']" routerLinkActive="active" class="btn btn-link"> {{ 'HOME.CAREER' | translate }} </a> </h2>
 <h2 class="mb-0"> <a [routerLink]="['/contact']" routerLinkActive="active" class="btn btn-link"> {{ 'HOME.CONTACT' | translate }} </a> </h2>
 <h2 class="mb-0"> <a [routerLink]="['/order-online']" routerLinkActive="active" class="btn btn-link"> {{ 'HOME.orderonline' | translate }} </a> </h2>
 
 <hr class="hr-nav mb-2">

 <div class="welcome-user">
 
         
 <div class="myaccount-menumob">
     <a class="dropdown-item" [routerLink]="['/my-account']"> {{ 'HOME.my_account' | translate }} </a>
     <a class="dropdown-item" [routerLink]="['/my-account/editprofile']"> {{ 'HOME.edit_profile' | translate }} </a>
     <a class="dropdown-item" [routerLink]="['/my-account/myaddresses']"> {{ 'HOME.my_addresses' | translate }} </a>
     <a class="dropdown-item" [routerLink]="['/my-account/orders']"> {{ 'HOME.my_orders' | translate }} </a>
     <a class="dropdown-item" [routerLink]="['/my-account/ongoing-orders']"> {{ 'HOME.track_order' | translate }} </a>
     <a class="dropdown-item" [routerLink]="['/my-account/my-wishlist']"> {{ 'HOME.my_favorites' | translate }} </a>
     <div class="dropdown-divider"></div>
     <a class="dropdown-item" (click)="logout()"> {{ 'HOME.logout' | translate }} </a>
   </div>

   
 <a class="sign-in" [routerLink]="['/login']" *ngIf="!isloggedin"> 
   <i class="fas fa-lock"></i> 
   Sign In</a>
</div>
 </div>
 </div>
<hr class="hr-nav mb-2">
<select class="navbar-language" #langs2 (change)="useLanguage(langs2.value)">
  <option value="en" selected="{{seletedEn}}"> English </option>
  <option value="ar" selected="{{seletedAr}}"> عربى </option>
</select>
 </div>
 </div>
 </div>



  <!-- header for desktop -->

   <nav class="navbar navbar-expand-lg d-none d-md-block navbar-light fixed-top" id="mainNav">
    <div class="container-fluid">
        <a class="navbar-search btn btn-sm btn-success" href="#"><i class="fas fa-search"></i></a>
        <form class="form-inline" #searchformdesk="ngForm" (ngSubmit)="onsearchsubmit(searchformdesk)">
            <div class="form-group mr-2">
               <input type="text" class="form-control search-form" name="searchtxt" 
               id="search" placeholder="{{ 'HOME.type_search' | translate }}" required ngModel>
            </div>
        </form>

        <!-- <a class="orderonline download-app" target="_blank" href=""> <i class="fas fa-mobile-alt"></i> Download App </a> -->
        <ul class="navbar-nav d-flex align-items-center mx-auto my-2 my-lg-0">
            <li class="nav-item"><a [routerLink]="['/about']" routerLinkActive="active" class="nav-link"> {{ 'HOME.ABOUT' | translate }} </a></li>
            <li class="nav-item"> <a [routerLink]="['/menu']" routerLinkActive="active" class="nav-link"> {{ 'HOME.MENU' | translate }} </a> </li>
            <li class="nav-item"> <a [routerLink]="['/shisha']" routerLinkActive="active" class="nav-link"> {{ 'HOME.SHISHA' | translate }} </a> </li>
            <li class="navbar-brand"> <a  href="/"> <img src="assets/img/logo.png" class="img-fluid" alt=""> </a></li>
            <li class="nav-item"><a routerLinkActive="active" [routerLink]="['/career']" class="nav-link"> {{ 'HOME.CAREER' | translate }} </a></li>
            <li class="nav-item"><a routerLinkActive="active" [routerLink]="['/contact']" class="nav-link">{{ 'HOME.CONTACT' | translate }}</a></li>
        </ul>
        <a class="orderonline" [routerLink]="['/order-online']"> {{ 'HOME.orderonline' | translate }} </a>

       

        <div class="welcome-user dropdown">
            <a class="mr-2 dropdown-toggle" id="userDropdown" data-toggle="dropdown" *ngIf="isloggedin" aria-haspopup="true" aria-expanded="false"> Hala, {{uname}}</a>          
                    
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
              <a class="dropdown-item" [routerLink]="['/my-account']"> {{ 'HOME.my_account' | translate }} </a>
              <a class="dropdown-item" [routerLink]="['/my-account/editprofile']"> {{ 'HOME.edit_profile' | translate }} </a>
              <a class="dropdown-item" [routerLink]="['/my-account/myaddresses']"> {{ 'HOME.my_addresses' | translate }} </a>
              <a class="dropdown-item" [routerLink]="['/my-account/orders']"> {{ 'HOME.my_orders' | translate }} </a>
              <a class="dropdown-item" [routerLink]="['/my-account/ongoing-orders']"> {{ 'HOME.track_order' | translate }} </a>
              <a class="dropdown-item" [routerLink]="['/my-account/my-wishlist']"> {{ 'HOME.my_favorites' | translate }} </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="logout()"> {{ 'HOME.logout' | translate }} </a>
              </div>
             
            <a class="sign-in" [routerLink]="['/login']" *ngIf="!isloggedin"> 
              <i class="fas fa-lock"></i> 
              Sign In</a>
        </div>

        <a class="cart-icon" routerLinkActive="active" [routerLink]="['/cart']">
           
            <i class="fas fa-shopping-cart"></i>
            <span class="cart-count"*ngIf="totalcartItem > 0" >{{totalcartItem}} </span>
        </a>
        <select class="navbar-language ml-2" #langs (change)="useLanguage(langs.value)">
          <option value="en" selected="{{seletedEn}}"> English </option>
          <option value="ar" selected="{{seletedAr}}"> عربى </option>
        </select>
    </div>
</nav>
